export default "__VITE_ASSET__CqY_fbuC__";